import themes from '../../theming/themes.js';
import React from 'react';

var DropdownContext = /*#__PURE__*/React.createContext({
  buttonText: 'Dropdown',
  firstSubMenuItem: /*#__PURE__*/React.createRef(),
  iconSize: 'xs',
  isOpen: false,
  navigateToSubMenuItems: function navigateToSubMenuItems() {},
  setIsOpen: function setIsOpen() {},
  theme: themes["default"],
  toggleMenu: function toggleMenu() {}
});

export { DropdownContext };
